// Code review - In Progress
// Documentation - In Progress

import React, { useEffect, useState } from "react";
import { partnermapingHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import MainPopup from "../popup-containers/MainPopup";
import toast from "react-hot-toast";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import MultiSelect from "../ReusableComponents/MultiSelect";
import PartnerMappingPopup from "../popup-containers/PartnerMappingPopup";
import Loader from "../ReusableComponents/Loader";

const Maping = () => {
  const location = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [partnerMappingId, setPartnerMappingId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // set CreatedBy from Session Storage
  const createdBy = sessionStorage.getItem("createdBy");
  const [isOpen, setIsOpen] = useState(false);
  const [partnerMappingData, setPartnerMappingData] = useState("");
  // Bind Dropdown Values
  const [bindCompanyDatas, setCompanyDatas] = useState([]);
  const [bindChainPartnerDatas, setChainPartnerDatas] = useState([]);
  const [bindPartnerMappingDatas, setBindPartnerMappingDatas] = useState([]);
  const [bindPartnerMappingDatas1, setBindPartnerMappingDatas1] = useState([]);
  const [bindPartnerMappingDatas2, setBindPartnerMappingDatas2] = useState([]);
  // Selected Dropdown Values

  const [partnerMappingFields, setPartnerMappingFields] = useState({
    company: [],
    valueChainPartner: [],
    date: "",
  });

  const [partnerMappingFieldsError, setPartnerMappingFieldsError] = useState({
    companyError: "",
    valueChainPartnerError: "",
  });

  // Bind Company and Value Chain Partner dropdown values start
  // Utility: format dropdown data
  const formatDropdownData = (data) =>
    data.map((m) => ({
      value: m.MstPartnerId,
      label: `${m.PartnerName} ${m.Type}`,
    }));

  // Bind Company and Chain Partner dropdowns
  useEffect(() => {
    const fetchPartnerDropdownData = async () => {
      try {
        const response = await BindAPI("PartnerAPI/BindPartner");
        const partners = response?.data?.Table || [];

        const activePartners = partners.filter((p) => p.Status === "Active");

        const companyList = formatDropdownData(
          activePartners.filter((p) => p.Type === "C")
        );
        const chainPartnerList = formatDropdownData(
          activePartners.filter((p) => p.Type === "VCP")
        );

        setCompanyDatas(companyList);
        setChainPartnerDatas(chainPartnerList);
      } catch (error) {
        console.error("Error fetching partner dropdown data:", error);
      }
    };

    fetchPartnerDropdownData();
  }, []);

  // Set Current Date
  useEffect(() => {
    const formattedDate = new Date().toISOString().split("T")[0];
    setPartnerMappingFields((prev) => ({
      ...prev,
      date: formattedDate,
    }));
  }, []);

  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

const BindPartnerMappingGridData = async () => {
  try {
    setIsLoading(true);
    const { data } = await BindAPI("PartnerMappingAPI/BindPartnerMapping");

    if (data) {
      setBindPartnerMappingDatas(data.Table ?? []);
       if (Array.isArray(data?.Table)) {
      if (data?.Table.length > 0) {
        setVisibleTable(true);
        setVisibleAdd(false);
      }
      else {
        showAdd();
      }
    }
      setBindPartnerMappingDatas1(data.Table1 ?? []);
      setBindPartnerMappingDatas2(data.Table2 ?? []);
    }
  } catch (error) {
    console.error("Error fetching Partner Mapping data:", error);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  BindPartnerMappingGridData();
}, []);


  // Add Functionality
  const showAdd = () => {
    
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setPartnerMappingFields({
      ...partnerMappingFields,
      company: [],
      valueChainPartner: [],
      date: formattedDate,
    });
    localStorage.setItem("screenMode", "add");
  };

  // Cancel Functionality
  const cancel = () => {
    
   
    
   
    setIsLoading(false);
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setSubmitVisibleButton(false);
    BindPartnerMappingGridData();
    setPartnerMappingId("");
    setPartnerMappingData("");
    
  // setPartnerMappingFields((prev) => ({
  //   ...prev,
  //   company: [],
  //   valueChainPartner: [],
  //     date: "",
  // }));
  setPartnerMappingFields({
      
      company: [],
      valueChainPartner: [],
      date: "",
    });
    setPartnerMappingFieldsError({
      
      companyError: "",
      valueChainPartnerError: "",
    });
    
    localStorage.setItem("screenMode", "");
  };

  // Edit Functionality
  const handleEdit = async (rowIndex) => {
    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    localStorage.setItem("screenMode", "edit");
    localStorage.setItem("selectedRowIndex", rowIndex);
    const rowData = bindPartnerMappingDatas[rowIndex];
    const matchedCompany = bindCompanyDatas.find(
      (item) => item.value === rowData.MstCompanyId
    );
    setPartnerMappingId(rowData.MstCompanyId);
    const valueChainPartnerIds = rowData.MstValueChainPartnerIds.split(",");
    const matchedValueChainPartners = bindChainPartnerDatas.filter((item) =>
      valueChainPartnerIds.includes(String(item.value))
    );

    var Date = bindPartnerMappingDatas[rowIndex].Date;
    const DatePart = Date.split("T")[0];

    setPartnerMappingFields({
      ...partnerMappingFields,
      company: matchedCompany ? [matchedCompany] : [],
      valueChainPartner: matchedValueChainPartners || [],
      date: DatePart,
    });
  };

  // Popup Functionality
  const handlePartnerMapping = (rowIndex, flag) => {
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }

    const rowData = bindPartnerMappingDatas[rowIndex];
    var Date = bindPartnerMappingDatas[rowIndex].Date;
    const DatePart = Date.split("T")[0];

    setPartnerMappingFields({
      ...partnerMappingFields,
      date: DatePart,
    });
    setPartnerMappingId(rowData.MstPartnerMappingId);
    setPartnerMappingData(rowData);
  };

  // Submit Functionality
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    
    if (flag == 1 || flag == 2) {
      const isFormError = {
        ...partnerMappingFieldsError,
        companyError:
          partnerMappingFields.company &&
          partnerMappingFields.company.length === 0
            ? "Select Company"
            : "",
       valueChainPartnerError:
  // If company is empty
  (!partnerMappingFields.company || partnerMappingFields.company.length === 0)
    ? !partnerMappingFields.valueChainPartner || partnerMappingFields.valueChainPartner.length === 0
      ? "Select Value Chain Partner"
      : ""
    : // If company is selected, perform full validation
    partnerMappingFields.valueChainPartner &&
      partnerMappingFields.valueChainPartner.length > 0
      ? updateScreenTitle &&
        partnerMappingFields.valueChainPartner.some((partner) =>
          bindPartnerMappingDatas2.some(
            (x) =>
              x.MstCompanyId === partnerMappingFields.company[0].value &&
              x.MstValueChainPartnerId === partner.value
          )
        )
        ? "Can not modify the mapping."
        : updateScreenTitle || addScreenTitle
        ? partnerMappingFields.valueChainPartner
            .filter((partner) =>
              bindPartnerMappingDatas1.some(
                (x) =>
                  x.MstCompanyId === partnerMappingFields.company[0].value &&
                  x.MstValueChainPartnerId === partner.value
              )
            )
            .map(
              (partner) =>
                `${partnerMappingFields.company[0].label} and ${partner.label} Already Mapped`
            )
        : ""
      : "Select Value Chain Partner"


        // valueChainPartnerError:
        //   partnerMappingFields.valueChainPartner &&
        //   partnerMappingFields.valueChainPartner.length > 0
        //     ? updateScreenTitle &&
        //       partnerMappingFields.valueChainPartner.some((partner) =>
        //         bindPartnerMappingDatas2.some(
        //           (x) =>
        //             x.MstCompanyId === partnerMappingFields.company[0].value &&
        //             x.MstValueChainPartnerId === partner.value
        //         )
        //       )
        //       ? `Can not modify the mapping.`
        //       : updateScreenTitle || addScreenTitle
        //       ? partnerMappingFields.valueChainPartner
        //           .filter((partner) =>
        //             bindPartnerMappingDatas1.some(
        //               (x) =>
        //                 x.MstCompanyId ===
        //                   partnerMappingFields.company[0].value &&
        //                 x.MstValueChainPartnerId === partner.value
        //             )
        //           )
        //           .map(
        //             (partner) =>
        //               `${partnerMappingFields.company[0].label} and ${partner.label} Already Mapped`
        //           )
        //       : ""
        //     : "Select Value Chain Partner",
      };
      
      setPartnerMappingFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === "" || (Array.isArray(error) && error.length === 0)
      );

      if (isFormValid) {
        setIsLoading(true);
        setSubmitBtnDisabled(true);

        let companyData = [];
        companyData = convertArrayToJSONString(partnerMappingFields.company);

        let valueChainPartnerData = [];
        valueChainPartnerData = convertArrayToJSONString1(
          partnerMappingFields.valueChainPartner
        );

        const customerPayload = [
          {
            partnerMappingId: partnerMappingId ? partnerMappingId : 0,
            companyId: companyData,
            valueChainPartnerId: valueChainPartnerData,
            date: partnerMappingFields.date,
            createdby: createdBy,
            flag: flag,
          },
        ];

        const response = await IUDAPI(
          customerPayload,
          "PartnerMappingAPI/IUDPartnerMapping"
        );

        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Partner Mapping added successfully 👍", {
              duration: 3000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);

            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Partner Mapping data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("Partner Mapping updated successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update Partner Mapping data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        setIsOpen(true);
      }
    } else {
      const data = {
        partnerMappingId: partnerMappingId,
        date: partnerMappingFields.date,
        createdby: createdBy,
        flag: flag,
      };
      const response = await IUDAPI(
        [data],
        "PartnerMappingAPI/IUDPartnerMapping"
      );
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(
            "Partner Mapping data deleted successfully 🗑️",
            5000,
            cancel()
          );
        } else {
          toast.error("Failed to delete Partner Mapping data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            "Partner Mapping data blocked successfully 🚫",
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to block Partner Mapping data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
            "Partner Mapping data unblocked successfully ✅",
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to unblock Partner Mapping data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };

  const customerChange = (updatedOptions) => {
    const selectedItems = bindChainPartnerDatas.filter((item) =>
      updatedOptions.includes(item.value)
    );

    setPartnerMappingFields((prevFields) => ({
      ...prevFields,
      valueChainPartner: selectedItems,
    }));
  };

  const customerChange1 = (updatedOptions) => {
    const selectedItems = bindCompanyDatas.filter((item) =>
      updatedOptions.includes(item.value)
    );
    setPartnerMappingFields((prevFields) => ({
      ...prevFields,
      company: selectedItems,
    }));
    setPartnerMappingFields((prevFields) => ({
      ...prevFields,
      valueChainPartner: [],
    }));
    // company is empty, but valueChainPartner has value — no error
                                  setPartnerMappingFieldsError((prev) => ({
                                    ...prev,
                                    valueChainPartnerError: "",
                                  }));
  };

  // Screen path setting
  useEffect(() => {
    if (location.pathname === "/partnermaping") {
      const screenMode = localStorage.getItem("screenMode");
      if (screenMode === "add") {
        setVisibleAdd(true);
        setVisibleTable(false);
        setAddScreenTitle(true);
        setUpdateScreenTitle(false);
      } else if (screenMode === "edit") {
        const storedIndex = localStorage.getItem("selectedRowIndex");
        if (storedIndex !== null && bindPartnerMappingDatas.length > 0) {
          handleEdit(Number(storedIndex));
        }
      }
    }
  }, [location, bindPartnerMappingDatas]);

  const [companyDetails, setCompanyDetails] = useState([]);
  const [valueChainPartnerDetail, setValueChainPartnerDetail] = useState([]);

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setCompanyDetails(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const convertArrayToJSONString1 = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setValueChainPartnerDetail(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && !isLoading &&(
        <GridPage
          title="Partner Mapping"
          header={partnermapingHeader}
          records={bindPartnerMappingDatas}
          blockView={false}
          handleEdit={handleEdit}
          handleAction={handlePartnerMapping}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <div class=" flex flex-col w-full">
          <div class={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Partner Mapping"
            />

            <div class={mainTable.addShadowScreen}>
              <div class={mainTable.mainContentScreen}>
                <form class={"relative overflow-visible p-5"}>
                  <div className="flex justify-center">
                    <div className="w-3/4">
                      <div class="grid gap-4 mb-2 md:grid-cols-2">
                        <div>
                          <MultiSelect
                            classStar="text-red-500"
                            label="Company"
                            filteredOptions={bindCompanyDatas}
                            classFilterLabel="p-1 flex gap-1"
                            class="custom-class"
                            placeholder={
                              partnerMappingFields.company?.length > 0
                                ? "More Selected"
                                : "Select..."
                            }
                            name="ServiceSubCategory"
                            selectedOptions={
                              partnerMappingFields.company
                                ? partnerMappingFields.company.map(
                                    (item) => item.value
                                  )
                                : ""
                            }
                            controlFuncBlur={() => {
                              if (
                                !partnerMappingFields.company ||
                                partnerMappingFields.company.length === 0
                              ) {
                                setPartnerMappingFieldsError((prev) => ({
                                  ...prev,
                                  companyError: "Select Company",
                                }));
                              } else {
                                setPartnerMappingFieldsError((prev) => ({
                                  ...prev,
                                  companyError: "",
                                }));
                              }
                            }}
                            classDiv="relative w-full inline-block"
                            onChange={customerChange1}
                            classLabel={mainTable.labelNoWrap}
                          />
                          {partnerMappingFieldsError.companyError && (
                            <span className="text-red-500">
                              {partnerMappingFieldsError.companyError}
                            </span>
                          )}

                          {partnerMappingFields.company?.length >= 0 && (
                            <div className="mt-2">
                              <div className="flex flex-col gap-2">
                                {partnerMappingFields?.company?.map(
                                  (item, index) => (
                                    <span
                                      key={index}
                                      className="bg-gray-100 px-2 py-1 w-fit rounded text-sm text-gray-800"
                                    >
                                      {item.label}
                                    </span>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                        <div>
                          <MultiSelect
                            classStar="text-red-500"
                            label="Value Chain Partner"
                            filteredOptions={bindChainPartnerDatas}
                            classFilterLabel="p-1 flex gap-1"
                            class="custom-class"
                            placeholder={
                              partnerMappingFields.valueChainPartner?.length > 0
                                ? "More Selected"
                                : "Select..."
                            }
                            name="valueChainPartner"
                            selectedOptions={
                              partnerMappingFields.valueChainPartner
                                ? partnerMappingFields.valueChainPartner.map(
                                    (item) => item.value
                                  )
                                : ""
                            }
                            // controlFuncBlur={() => {
                            //   if (
                            //     !partnerMappingFields.valueChainPartner ||
                            //     partnerMappingFields.valueChainPartner
                            //       .length === 0
                            //   ) {
                            //     setPartnerMappingFieldsError((prev) => ({
                            //       ...prev,
                            //       valueChainPartnerError:
                            //         "Select Value Chain Partner",
                            //     }));
                            //   } else if (
                            //     updateScreenTitle &&
                            //     partnerMappingFields.valueChainPartner.some(
                            //       (partner) =>
                            //         bindPartnerMappingDatas2.some(
                            //           (x) =>
                            //             x.MstCompanyId ===
                            //               partnerMappingFields.company[0]
                            //                 .value &&
                            //             x.MstValueChainPartnerId ===
                            //               partner.value
                            //         )
                            //     )
                            //   ) {
                            //     setPartnerMappingFieldsError((prev) => ({
                            //       ...prev,
                            //       valueChainPartnerError: `Can not modify the mapping.`,
                            //     }));
                            //   } else if (!updateScreenTitle) {
                            //     const newErrors = {};

                            //     partnerMappingFields.valueChainPartner.forEach(
                            //       (partner) => {
                            //         const isMapped =
                            //           bindPartnerMappingDatas1.some(
                            //             (x) =>
                            //               x.MstCompanyId ===
                            //                 partnerMappingFields.company[0]
                            //                   .value &&
                            //               x.MstValueChainPartnerId ===
                            //                 partner.value
                            //           );

                            //         if (isMapped) {
                            //           newErrors[
                            //             partner.value
                            //           ] = `${partnerMappingFields.company[0].label} and ${partner.label} Already Mapped`;
                            //         }
                            //       }
                            //     );

                            //     setPartnerMappingFieldsError((prev) => ({
                            //       ...prev,
                            //       valueChainPartnerError: newErrors, // store as an object with partner IDs as keys
                            //     }));
                            //   } else {
                            //     setPartnerMappingFieldsError((prev) => ({
                            //       ...prev,
                            //       valueChainPartnerError: "",
                            //     }));
                            //   }
                            // }}
                            controlFuncBlur={() => {
                              const selectedCompany =
                                partnerMappingFields.company?.[0];
                              const selectedPartners =
                                partnerMappingFields.valueChainPartner;

                              // 🟩 Case 1: company is empty
                              if (!selectedCompany) {
                                if (
                                  !selectedPartners ||
                                  selectedPartners.length === 0
                                ) {
                                  // company and valueChainPartner both empty — show error
                                  setPartnerMappingFieldsError((prev) => ({
                                    ...prev,
                                    valueChainPartnerError:
                                      "Select Value Chain Partner",
                                  }));
                                } else {
                                  // company is empty, but valueChainPartner has value — no error
                                  setPartnerMappingFieldsError((prev) => ({
                                    ...prev,
                                    valueChainPartnerError: "",
                                  }));
                                }
                                return;
                              }

                              // 🟩 Case 2: company has value — perform full validation
                              if (
                                !selectedPartners ||
                                selectedPartners.length === 0
                              ) {
                                setPartnerMappingFieldsError((prev) => ({
                                  ...prev,
                                  valueChainPartnerError:
                                    "Select Value Chain Partner",
                                }));
                              } else if (
                                updateScreenTitle &&
                                selectedPartners.some((partner) =>
                                  bindPartnerMappingDatas2.some(
                                    (x) =>
                                      x.MstCompanyId ===
                                        selectedCompany.value &&
                                      x.MstValueChainPartnerId === partner.value
                                  )
                                )
                              ) {
                                setPartnerMappingFieldsError((prev) => ({
                                  ...prev,
                                  valueChainPartnerError:
                                    "Can not modify the mapping.",
                                }));
                              } else if (!updateScreenTitle) {
                                const newErrors = {};

                                selectedPartners.forEach((partner) => {
                                  const isMapped =
                                    bindPartnerMappingDatas1.some(
                                      (x) =>
                                        x.MstCompanyId ===
                                          selectedCompany.value &&
                                        x.MstValueChainPartnerId ===
                                          partner.value
                                    );

                                  if (isMapped) {
                                    newErrors[
                                      partner.value
                                    ] = `${selectedCompany.label} and ${partner.label} Already Mapped`;
                                  }
                                });

                                setPartnerMappingFieldsError((prev) => ({
                                  ...prev,
                                  valueChainPartnerError:
                                    Object.keys(newErrors).length > 0
                                      ? newErrors
                                      : "",
                                }));
                              } else {
                                setPartnerMappingFieldsError((prev) => ({
                                  ...prev,
                                  valueChainPartnerError: "",
                                }));
                              }
                            }}
                            classDiv="relative w-full inline-block"
                            onChange={customerChange}
                            classLabel={mainTable.labelNoWrap}
                          />
                          {partnerMappingFieldsError.valueChainPartnerError &&
                            typeof partnerMappingFieldsError.valueChainPartnerError ===
                              "string" && (
                              <span className="text-red-500">
                                {
                                  partnerMappingFieldsError.valueChainPartnerError
                                }
                              </span>
                            )}

                          {partnerMappingFieldsError.valueChainPartnerError &&
                            typeof partnerMappingFieldsError.valueChainPartnerError ===
                              "object" &&
                            Object.entries(
                              partnerMappingFieldsError.valueChainPartnerError
                            ).map(([key, message]) => (
                              <span key={key} className="text-red-500 block">
                                {message}
                              </span>
                            ))}
                          {partnerMappingFields.valueChainPartner?.length >
                            0 && (
                            <div className="mt-2">
                              <div className="flex flex-col gap-2">
                                {partnerMappingFields.valueChainPartner.map(
                                  (item, index) => (
                                    <span
                                      key={index}
                                      className="bg-gray-100 px-2 py-1 w-fit rounded text-sm text-gray-800"
                                    >
                                      {item.label}
                                    </span>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  // viewSaveButton={true}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
                {submitVisibleButton && (
                  <div className="border p-2 flex flex-col items-center justify-center "></div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Partner Mapping"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <PartnerMappingPopup data={partnerMappingData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Maping;
